export default function debounce(fn, wait) {
    let t
    // eslint-disable-next-line func-names
    return function() {
        clearTimeout(t)
        // eslint-disable-next-line prefer-rest-params
        t = setTimeout(() => fn.apply(this, arguments), wait)
    }
}
